export const KEY_COOKIE = 'lt_go_to_app_mobile_popup';
export const PROMOCODE = 'NEW10';
export const MOBILE_APP_TEST_ID = 'mobile-app-banner';
export const DONE_ICON_TEST_ID = 'done_icon';
export const COPY_ICON_TEST_ID = 'copy_icon';
